<template>
   <div class="page">
     <page-header ></page-header>
     
     <div class="banners"></div>

     <div class="c-container">
       <div class="main">
         <div class="left">
           <div class="logo">博久网络</div>
           <div class="li">
             公司简介
             <span></span>
           </div>
         </div>
         <div class="right">
           <div class="bojiu_company_intro t-text">
              <p>
                北京博久网络科技有限公司，成立于2015年，注册资金1000万。是一家专注于PC端、移动端的游戏运营的网络科技公司。公司拥有一批宣传策划、市
                场营销等方面具有丰富的经验和无尽的创造力的博久员工，秉承着“以精为业、以质取胜”的核心运营理念。
              </p>
              <p>
                自公司创立以来，不断钻研用户需求，不断打磨游戏产品的品质。在2015年5月由北京博久网络科技有限自主研发运营的大型网页游戏【凯旋归来】，
                一经推出受到业界好评，注册用户突破百万，铸造了网页游戏行业的成功案例。
              </p>
              <p>
                2016年7月北京博久网络科技有限公司与湖南旗胜网络科技有限公司达成战略合作伙伴，联合运营—【闲逸棋牌系列游戏】。由湖南旗胜网络科技有限
                公司负责研发产品，北京博久网络科技有限公司负责运营。强强联手只为给用户群体打造出最高端品质的休闲棋牌游戏平台。运营方向倾向于“地方
                特色棋牌”，尤其是为中小型城市的手机用户提供”休闲益智”与”地方特色文化”相结合的创新型产品。
              </p>
              <p>
                自合作以来陆续推闲逸碰胡、闲逸六胡抢、闲逸麻将、闲逸晃晃、闲逸偎麻雀，闲逸跑得快等手机棋牌游戏。各年龄层的玩家均可以在闲逸互动平台与
                其它的玩家进行互动，让不同地区的用户都可以享受棋牌运动的地方文化与竞技乐趣。”
              </p>
            </div>
         </div>
       </div>
      </div>
     <page-footer v-if="$route.meta.hasFooter"></page-footer>
   </div>
</template>
<script>
import Vue from 'vue'

export default {
  components: {
    pageFooter: () => import('@/components/footer'),
    pageHeader: () => import('@/components/layout/page-header')
  },
  data () {
    return {
     
    }
  },
  created () {
  },
  mounted () {
  },
  
  methods: {
    
  }
}
</script>
<style lang="less" scoped>
.main{
  max-width: 512px;
  margin: 0 auto;
  position: relative;
}

.banners{
  height: 175px;
  background: url(../../assets/images/about-barnner.jpg) no-repeat center;
  background-size: cover;
}

.c-container{
	width: 100%;
	clear: all;
	overflow: hidden;
  padding-top: 15px;
  .main{
    display: flex;
    justify-content: space-between;
  }
  .left {
    width: 120px;
    .logo{
      height: 24px;
      background: #f48041;
      display: flex;
      justify-content: center;
      align-items: center;
      color: #fff;
    }
    .li{
      height: 40px;
      box-sizing: border-box;
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding:0 10px;
      font-size: 10px;
      
      border-bottom: 1px solid #f48041;
      cursor: pointer;
      span{
        width: 8px;
        height: 8px;
        background: url(../../assets/images/a-hover.gif) no-repeat;
        background-size: 5px auto;
      }
      &:hover{
        color: #f48041;
      }
    }
  }
  .right{
    width: 360px;
  }
}

.company_culture,.t-text{
	color: #333;
	margin-top: 10px;
	padding-left: 10px;
	padding-bottom: 25px;
	text-indent:2em;
}
.company-brief p,.company_culture p,.t-text p{
	font-family: "微软雅黑";
	line-height:18px;
	font-size: 8px;
	color: #000;
	font-weight: 500;
}


@media (max-width:800px) {
  .c-container{
    .main{
      display: block;
    }
    .left{
      width: 100%;
      .logo{
        display: none;
      }
    }
    
  }
}

</style>
